<!-- 对话列表 -->
<template>
  <div id="conversation" class="conversation tabs-ctn">
    <div class="tabs-btn-ctn">
      <div class="tab-btn-item" @click="tabToggle(0)" :class="{'tab-active':tabInd == 0}">对话列表</div>
      <div class="tab-btn-item" @click="tabToggle(1)" :class="{'tab-active':tabInd == 1}">接入等待</div>
    </div>
    <div class="tabs-content">
      <div class="tab-section" v-show="tabInd == 0 " style="padding: 0!important;">
        <div
          v-for="(item,index) in chatList"
          :key="item.uId"
          class="chat-item"
          :class="{'chat-item-active':chatItemActInd == index}"
        >
          <div class="chat-type" v-if="item.transferId">转</div>
          <img :src="item.avatarUrl" alt="" class="chat-item-head" @click="chatWith(item,index)">
          <div class="kh-name">
            <span class="in-one-line" @click="chatWith(item,index)">{{item.uName}}</span>
          </div>
          <div v-if="item.isLeave">
            <span class="leave-dian"></span>离线
          </div>
          <div v-else>
            <span class="zai-dian"></span>在线
          </div>
          <div class="flex" style="align-items: center">
            <div class="no-read-number" v-if="item.UnreadNum != 0">{{item.UnreadNum}}</div>
            <div v-else style="width: 30px"></div>
            <i class="el-icon-close" @click="stopChat(item,index)" title="停止对话"></i>
          </div>
        </div>
      </div>
      <div class="tab-section wait" v-show="tabInd == 1 ">
        <div class="wait-title">
          <span>目前等待人数{{waitNum}}人</span>
          <!--<el-button type="primary" size="mini" @click="AllJoinChat">全部接入</el-button>-->
        </div>
        <div v-for="(item,index) in waitChatList" :key="item.uId" class="chat-item">
          <img :src="item.avatarUrl" alt="" class="chat-item-head">
          <div class="kh-name">
            <span class="in-one-line">{{item.uName}}</span>
          </div>
          <div v-if="item.isLeave">
            <span class="leave-dian"></span>离线
          </div>
          <div v-else>
            <span class="zai-dian"></span>在线
          </div>
          <div>
            <el-button size="mini" @click="joinChat(item,index)">接入</el-button>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>
<script>
export default {
  name: "conversation",
  components: {},
  data() {
    return {
      chatItemActInd: -1,
      stateli: false, //客服在线状态
      tabInd: 0,
      waitNum: 0,
      chatNum: 0,
      accessCount: 0,
      customerList: [],
      chatList: [], // 对话列表
      waitChatList: [] // 接入等待
    };
  },
  computed: {
    // socket 状态
    socketStatus() {
      return this.$store.state.connectState;
    },
    getCurrChatClient() {
      return this.$store.getters.getCurrChatClient;
    }
  },
  watch: {
    socketStatus(value) {
      // 客服主动下线,重新加载列表
      if (value == 0) {
        this.stateli = true;
      } else if (value == 2) {
        this.stateli = false;
      }
    },
    //监听当前聊天客户
    getCurrChatClient(value) {
      let _chatList = this.chatList;
      //当前没有选中的客户
      if (JSON.stringify(value) == "{}") {
        this.chatItemActInd = -1; //移除选中
      } else if (value.isLeave && !value.IsShow) {
        // 留言
        //处理留言时在线列表的选中状态
        let inlist = false;
        for (let i = 0; i < _chatList.length; i++) {
          if (_chatList[i].uId == this.$store.state.customerMsg.uId) {
            inlist = true;
            this.chatItemActInd = i;
            break;
          }
        }
        if (!inlist) this.chatItemActInd = -1; //移除选中
      } else if (value.isLeave) {
        //客户离线
        for (let i = 0; i < _chatList.length; i++) {
          if (_chatList[i].uId == this.$store.state.customerMsg.uId) {
            this.chatItemActInd = i;
            break;
          }
        }
      }
    }
  },
  mounted() {},
  methods: {
    //添加客户到对话列表
    addCustomerToChattingList(uId, isSel = true) {
      let that = this;
      let _chatList = this.chatList;
      for (let i = 0; i < _chatList.length; i++) {
        if (_chatList[i].uId == uId) {
          return;
        }
      }
      this.$util.AddCustomerToChat(uId).then(res => {
        let data = res.data.data;
        if (data) {
          that.chatList.push(data); //加入列表
          if (isSel) {
            //判断是否选中
            that.chatWith(data, that.chatList.length - 1); //选中
          } else {
            let nowChatUid = this.$store.state.customerMsg.uId;
            // 重置索引
            if (!nowChatUid) {
              that.chatItemActInd = -1;
              return;
            }
            for (let i = 0; i < _chatList.length; i++) {
              if (_chatList[i].uId == nowChatUid) {
                that.chatItemActInd = i;
                break;
              }
            }
          }
          //更新今日访客列表
          this.$emit("uploadTodayVisitorsList");
        }
      });
    },
    // 更新列表中未读消息的数量
    updateNoRead(result) {
      let _chatList = this.chatList;
      for (let i = 0; i < _chatList.length; i++) {
        if (_chatList[i].uId == result.sender) {
          _chatList[i].showNum = true;
          _chatList[i].UnreadNum += 1;
        }
      }
    },
    // 请求今天的与客户聊天列表
    GetChattingList(message) {
      if (message && message.transferId) {
        const h = this.$createElement;
        this.$notify({
          title: "您收到了一个客户转接",
          message: h(
            "i",
            { style: "color: teal" },
            `${message.transferMan}将${message.uName}转接给了您`
          )
        });
      }
      this.axios
        .get("/ChatCenter/GetChatClientList", {
          params: {
            sid: this.$util.getSessionStorage("userMsg").Id
          }
        })
        .then(res => {
          this.ReceiveTodayChat(res);
        });
    },
    // 接收今天的与客户聊天列表
    ReceiveTodayChat(message) {
      let list = message.data.data.ChatClients;
      let _chatList = []; // 对话列表
      let _waitChatList = []; // 接入等待
      this.chatNum = 0;
      this.waitNum = 0;
      let nowChatUid = this.$store.state.customerMsg.uId;
      for (let i = 0; i < list.length; i++) {
        if (list[i].isJoin) {
          list[i].showNum = false;
          _chatList.push(list[i]);
          this.chatNum += 1;
          if (list[i].uId == nowChatUid) {
            //判断当前的对话客户
            this.chatItemActInd = i;
          }
        } else {
          _waitChatList.push(list[i]);
          this.waitNum += 1;
        }
      }
      this.customerList = list;
      this.chatList = _chatList;
      this.waitChatList = _waitChatList;
      this.$store.commit("updateChatingList", this.chatList);
    },
    // tab切换
    tabToggle(i) {
      this.tabInd = i;
    },
    // 接入客户
    joinChat(item) {
      if (this.stateli) {
        return;
      }
      this.axios
        .post("/ChatCenter/JoinCustomer", {
          sId: this.$util.getSessionStorage("userMsg").Id,
          clients: [
            {
              cId: item.uId,
              sessionId: item.sessionId,
              transferId: item.transferId
            }
          ]
        })
        .then(() => {
          this.GetChattingList();
          //更新今日访客列表
          this.$emit("uploadTodayVisitorsList");
        });
    },
    // 踢出聊天列表
    stopChat(item) {
      if (this.stateli) {
        return;
      }
      let that = this;
      let _chatList = that.chatList;
      this.$util.stopChat(item.sessionId).then(res => {
        for (let i = 0; i < _chatList.length; i++) {
          if (_chatList[i].uId == item.uId) {
            // that.chatList.splice(i, 1);
            _chatList.splice(i, 1);
            break;
          }
        }
        this.$store.commit("updateChatingList", this.chatList);
        let nowChatUid = this.$store.state.customerMsg.uId;
        if (item.uId == nowChatUid) {
          this.$store.commit("updateCustomerMsg", {}); //清空当前聊天客户
          that.chatItemActInd = -1; //清空索引
        } else {
          // 重置索引
          for (let i = 0; i < _chatList.length; i++) {
            if (_chatList[i].uId == nowChatUid) {
              that.chatItemActInd = i;
              break;
            }
          }
        }
        that.chatList = _chatList;
        //更新今日访客列表
        that.$emit("uploadTodayVisitorsList");
        // that.$emit("uploadChatList", item); //更新今日访客与对话列表
      });
    },
    // 和这个人吹水
    chatWith(item, index) {
      if (this.stateli) {
        return;
      }
      // let nowChatUid = this.$store.state.customerMsg.uId;
      // if (item.uId == nowChatUid) {
      //   return;
      // }
      if (this.chatList[index].UnreadNum != 0) {
        this.$util.markRead(item.uId, item.uType ? item.uType : 1, this);
      }
      this.chatList[index].UnreadNum = 0;
      this.chatItemActInd = index;
      this.$store.commit("updateCustomerMsg", item);
      //   this.$emit("chatWith", item);
    }
  }
};
</script>
<style lang="less" scoped>
.tab-section {
  padding: 10px 10px 0 !important;
}
.no-read-number {
  width: 30px;
  height: 16px;
  text-align: center;
  line-height: 16px;
  border-radius: 16px;
  background: @theme;
  color: white;
  font-size: 12px;
  margin-right: 5px;
}
.conversation {
  height: 100%;
  overflow: auto;
}
.chat-item {
  position: relative;
  display: flex;
  justify-content: space-between;
  align-items: center;
  padding: 10px 10px 10px 20px;
  .in-one-line {
    display: inline-block;
  }
  i {
    font-size: @font-sm;
    color: @theme;
  }
}
.chat-item-active {
  background: @border3Color;
}
.chat-type {
  position: absolute;
  left: 0;
  top: 15px;
  color: white;
  background: @theme;
  border-radius: 50%;
  display: inline-block;
  padding: 3px;
  font-size: 12px;
}

.wait-title {
  display: flex;
  justify-content: space-between;
  align-items: center;
  padding-bottom: 20px;
}
// .wait {
// }
.kh-name {
  cursor: pointer;
  width: 30%;
  text-overflow: ellipsis;
  overflow: hidden;
  white-space: nowrap;
}
.chat-item-head {
  width: 30px;
  height: 30px;
  border-radius: 50%;
  cursor: pointer;
}
.leave-dian {
  width: 10px;
  height: 10px;
  border-radius: 50%;
  background: darkgray;
  display: inline-block;
}
.zai-dian {
  width: 10px;
  height: 10px;
  border-radius: 50%;
  background: greenyellow;
  display: inline-block;
}
</style>
